<script lang="ts">
import { type PropType } from "vue";
import CardCol from "./CardCol.vue";
import CardRow from "./CardRow.vue";
import { createBuiltInComponents } from "./components/index";
import type { Feature } from "./type";
const componentsMap = createBuiltInComponents();

export default defineComponent({
    props: {
        source: {
            type: Object as PropType<Partial<Feature>>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    setup(props, { slots }) {
        const currentSlots = computed(() => {
            let { slots: _slots, ...reset } = props.source;
            if (!_slots) return slots;
            let result: { [key: string]: any } = {};
            for (const key in _slots) {
                if (Object.prototype.hasOwnProperty.call(_slots, key)) {
                    const element = _slots[key];
                    const component = slots[key] || componentsMap.get(element);
                    result[key] = () => h(defineAsyncComponent(component), { source: (reset as any)[key], index: props.index });
                    if (!result[key]) {
                        console.error("解析组件失败");
                    }
                }
            }
            return { ...result, ...slots };
        });

        return () => {
            let { source, index } = props;
            let component = source.styleCard === 1 ? CardRow : CardCol;
            return h(component, { source: source, index: index }, currentSlots.value);
        };
    },
    // render() {
    //     let { source, index } = this;
    //     let { slot } = source;
    //     source.
    //     console.log("🚀 -> file: index.vue:13 -> render -> source, index ", source, index);
    //     return h(CardCol, { source: source, index: index }, this.$slots);
    // },
});
</script>
